"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openingMeterReadToMeterRead = void 0;
function openingMeterReadToMeterRead(omr) {
    return 'registers' in omr
        ? {
            mpxn: omr.mpxn,
            readingDateTime: omr.readDate,
            readingType: 'OpeningReadingActual',
            tiers: omr.registers.map(function (_a) {
                var read = _a.read, timeOfUseLabel = _a.timeOfUseLabel;
                return ({
                    meterRegisterReading: read,
                    timeOfUseLabel: timeOfUseLabel,
                });
            }),
        }
        : {
            mpxn: omr.mpxn,
            readingDateTime: omr.readDate,
            readingType: 'OpeningReadingActual',
            gasVolume: omr.read,
        };
}
exports.openingMeterReadToMeterRead = openingMeterReadToMeterRead;
